<!-- start banner Area -->
<section class="banner-area relative" id="home">
  <div class="overlay overlay-bg"></div>
  <div class="container">
    <div class="row d-flex align-items-center justify-content-center">
      <div class="about-content col-lg-12">
        <h1 class="text-white">
          CV thèque
        </h1>
        <p class="text-white link-nav"><a [routerLink]="['/accueil', 'consultant']">Accueil</a> <span
            class="lnr lnr-arrow-right"></span>
          <span> CV thèque</span>
        </p>
      </div>
    </div>
  </div>
</section>
<!-- End banner Area -->

<!-- Start service Area -->
<section class="service-area section-gap" id="service">
  <div class="container">
    <div class="row pb-40">

      <!-- Informations personnelles -->
      <div class="col-md-6 mb-5">
        <fieldset class="form-area fieldset-panel">
          <legend class="legend-style" style="width: 65%;"> Informations personnelles </legend>
          <form [formGroup]="personalInfoForm" (ngSubmit)="onSubmitPersonalInfoForm()">
            <div style="margin-top: -5px; margin-bottom: 10px; color: red;">
              Cliquer sur le bouton <strong>"APPLIQUER LES MODIFICATIONS"</strong> après avoir effectuée des
              modifications sur le formulaire.
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="gender">Sexe <span class="star-style">**</span></label>
                <select class="form-control" id="gender" formControlName="gender">
                  <option value="Homme">Homme</option>
                  <option value="Femme">Femme</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label for="date_birth">Date de naissance <span class="star-style">**</span></label>
                <input type="date" class="form-control h-40px" id="date_birth" formControlName="date_birth">
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="last_name">Nom <span class="star-style">**</span></label>
                <input type="text" class="form-control h-40px" id="last_name" formControlName="last_name">
              </div>
              <div class="form-group col-md-6">
                <label for="first_name">Prénom <span class="star-style">**</span></label>
                <input type="text" class="form-control h-40px" id="first_name" formControlName="first_name">
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="email">Email <span class="star-style">**</span></label>
                <input type="hidden" class="form-control h-40px" formControlName="email">
                <input type="email" class="form-control h-40px" id="email" [value]="consultants.getEmail()" disabled>
              </div>
              <div class="form-group col-md-6">
                <label for="daily_fee">Honoraire journalier (F CFA) <span class="star-style">**</span></label>
                <select class="form-control" id="daily_fee" formControlName="daily_fee">
                  <option value="" selected>Sélectionner...</option>
                  <option value="15 000 à 30 000">15 000 à 30 000</option>
                  <option value="31 000 à 50 000">31 000 à 50 000</option>
                  <option value="51 000 à 80 000">51 000 à 80 000</option>
                  <option value="81 000 à 100 000">81 000 à 100 000</option>
                  <option value="101 000 à 150 000">101 000 à 150 000</option>
                  <option value="151 000 à 200 000">151 000 à 200 000</option>
                  <option value="201 000 à 250 000">201 000 à 250 000</option>
                  <option value="251 000 à 300 000">251 000 à 300 000</option>
                  <option value="Plus de 300 000">Plus de 300 000</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6"
                [ngClass]="cvValue == null ? 'form-group col-md-12' : 'form-group col-md-6'">
                <label for="curriculumVitae">Curriculum vitae <span style="font-size: 10px; font-weight: 700;">(pdf, <
                      1Mo)</span> <span class="star-style">**</span></label>
                <span class="btn btn-success w-100" *ngIf="cvValue == null" (click)="chooseNewCV()">Joindre curriculum
                  vitae</span>
                <span class="btn btn-success w-100" *ngIf="cvValue != null" (click)="chooseNewCV()">Remplacer CV</span>
                <span *ngIf="cvFile != null" style="font-size: 10px; font-weight: 700; color: green"> Super! Fichier
                  joint</span>
              </div>
              <div class="form-group col-md-6 my-auto pt-3">
                <a [href]="cvPath" target="_blank" class="btn btn-info w-100" *ngIf="cvValue != null">Afficher CV</a>
              </div>
            </div>

            <!-- Div block afficher/reduire -->
            <div id="infoBlock" style="display: none">
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="phone_1">Téléphone 1 <span class="star-style">**</span></label>
                  <input type="text" class="form-control h-40px" id="phone_1" formControlName="phone_1">
                </div>
                <div class="form-group col-md-6">
                  <label for="phone_2">Téléphone 2</label>
                  <input type="text" class="form-control h-40px" id="phone_2" formControlName="phone_2">
                </div>
              </div>
              <button type="submit" class="primary-btn text-white" [disabled]="personalInfoForm.invalid"
                *ngIf="!personalInfoIsLoading">Appliquer modification</button>
              <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="personalInfoIsLoading">
                Veuillez patienter...</p>
            </div>

            <!-- Label block afficher/reduire -->
            <div id="infoLabelToShowOrHide" class="labelBlock"
              (click)="functionsService.showOrHideBlock('infoBlock', 'infoLabelToShowOrHide')">
              Afficher plus
            </div>
          </form>
        </fieldset>
      </div>

      <!-- Missions -->
      <div class="col-md-6 mb-5">
        <fieldset class="form-area fieldset-panel">
          <legend class="legend-style" style="width: 50%;">Missions conduites</legend>
            <div style="margin-top: -5px; margin-bottom: 30px; color: red;">
              Faites nous savoir les missions que vous avez conduites. <br>
            </div>
          <form [formGroup]="missionsForm" (ngSubmit)="onSubmitMissionForm()">
            <div class="form-group">
              <label for="title">Titre mission <span class="star-style">**</span></label>
              <input type="text" class="form-control h-40px" id="title" formControlName="title" placeholder="Ex: Mission d'audit...">
            </div>
            <div class="row">
              <div class="form-group col-md-6"
                [ngClass]="certificatValue == null ? 'form-group col-md-12' : 'form-group col-md-6'">
                <label for="curriculumVitae">Certificat <span style="font-size: 10px; font-weight: 700;">(pdf, <
                      1Mo)</span> <span class="star-style">**</span></label>
                <span class="btn btn-success w-100" *ngIf="certificatValue == null" (click)="chooseNewCertificat()">Joindre le certificat</span>
                <span class="btn btn-success w-100" *ngIf="certificatValue != null" (click)="chooseNewCertificat()">Remplacer Certif.</span>
                <span *ngIf="certificatFile != null" style="font-size: 10px; font-weight: 700; color: green"> Super! Fichier
                  joint</span>
              </div>
              <div class="form-group col-md-6 my-auto pt-3">
                <a [href]="certificatPath" target="_blank" class="btn btn-info w-100" *ngIf="certificatValue != null">Afficher Certif.</a>
              </div>
            </div>
            <div class="form-group">
              <label for="description">Description des tâches <span class="star-style">**</span><span>(300 Caractères max)</span></label>
              <textarea class="form-control" id="description" rows="4" maxlength="300" formControlName="description" style="height: 100px;"></textarea>
            </div>
            <button type="submit" class="primary-btn text-white" [disabled]="missionsForm.invalid"
              *ngIf="!missionIsLoading">Ajouter</button>
            <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="missionIsLoading">Veuillez
              patienter...
            </p>

            <!-- Div block afficher/reduire -->
            <div id="missionBlock" style="display: none">
              <div class="form-group mt-5" style="width: 100%; overflow: auto;">
                <table class="table table-bordered">
                  <tr>
                    <th>Titre mission</th>
                    <th>Description</th>
                    <th>Certificat</th>
                    <th>Action</th>
                  </tr>
                  <tr *ngFor="let consultantMission of consultantMissionList">
                    <td>{{ consultantMission.getTitle() }}</td>
                    <td title="{{ consultantMission.getDescription() }}">{{ functionsService.wordWrap(consultantMission.getDescription(), 50) }}</td>
                    <td><a *ngIf="consultantMission.getCertificatPath() != ''" [href]="consultantMission.getCertificatPath()" target="_blank" class="btn btn-info">Voir</a></td>
                    <td><span class="btn btn-danger" (click)="removeMission(consultantMission.getId())">Supp</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- Label block afficher/reduire -->
            <div id="missionLabelToShowOrHide" class="labelBlock"
              (click)="functionsService.showOrHideBlock('missionBlock', 'missionLabelToShowOrHide')">
              Afficher plus
            </div>
          </form>
        </fieldset>
      </div>

      <!-- Produits souhaité -->
      <div class="col-md-4 mb-5">
        <fieldset class="form-area fieldset-panel">
          <legend class="legend-style" style="width: 40%;">Produits</legend>
            <div style="margin-top: -5px; margin-bottom: 30px; color: red;">
              Sur quel produit, voudriez-vous nous accompagner ?<br>
            </div>
          <form [formGroup]="produitsForm" (ngSubmit)="onSubmitProduitForm()">
            <div class="form-group">
              <label for="produit">Produits <span class="star-style">**</span></label>
              <select class="form-control" id="produit" formControlName="produit_id">
                <option value="">Selectionner...</option>
                <option [value]="produit.getId()" *ngFor="let produit of produitList">{{ produit.getLibelle() }}
                </option>
              </select>
            </div>
            <button type="submit" class="primary-btn text-white" [disabled]="produitsForm.invalid"
              *ngIf="!produitIsLoading">Ajouter</button>
            <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="produitIsLoading">Veuillez
              patienter...
            </p>

            <div class="form-group mt-5" style="width: 100%; overflow: auto;">
              <table class="table table-bordered">
                <tr>
                  <th>Produits choisis</th>
                  <th>Action</th>
                </tr>
                <tr *ngFor="let consultantProduit of consultantProduitList">
                  <td>{{ consultantProduit.getProduits()['libelle'] }}</td>
                  <td><span class="btn btn-danger" (click)="removeProduit(consultantProduit.getId())">Supp</span>
                  </td>
                </tr>
              </table>
            </div>
          </form>
        </fieldset>
      </div>

      <!-- Domaine d'expertise -->
      <div class="col-md-4 mb-5">
        <fieldset class="form-area fieldset-panel">
          <legend class="legend-style" style="width: 45%;">Expertises</legend>
            <div style="margin-top: -5px; margin-bottom: 55px; color: red;">
              Quels sont vos domaines d'expertises ?<br>
            </div>
          <form [formGroup]="expertisesForm" (ngSubmit)="onSubmitExpertiseForm()">
            <div class="form-group">
              <label for="expertise">Domaines d'expertises <span class="star-style">**</span></label>
              <select class="form-control" id="expertise" formControlName="expertise_id">
                <option value="">Selectionner...</option>
                <option [value]="expertise.getId()" *ngFor="let expertise of expertiseList">{{ expertise.getLibelle() }}
                </option>
              </select>
            </div>
            <button type="submit" class="primary-btn text-white" [disabled]="expertisesForm.invalid"
              *ngIf="!expertiseIsLoading">Ajouter</button>
            <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="expertiseIsLoading">Veuillez
              patienter...
            </p>

            <div class="form-group mt-5" style="width: 100%; overflow: auto;">
              <table class="table table-bordered">
                <tr>
                  <th>Expertises choisies</th>
                  <th>Action</th>
                </tr>
                <tr *ngFor="let consultantExpertise of consultantExpertiseList">
                  <td>{{ consultantExpertise.getExpertises()['libelle'] }}</td>
                  <td><span class="btn btn-danger" (click)="removeExpertise(consultantExpertise.getId())">Supp</span>
                  </td>
                </tr>
              </table>
            </div>
          </form>
        </fieldset>
      </div>

      <!-- Countries -->
      <div class="col-md-4 mb-5">
        <fieldset class="form-area fieldset-panel">
          <legend class="legend-style" style="width: 35%;">Pays</legend>
            <div style="margin-top: -5px; margin-bottom: 30px; color: red;">
              Dans quels pays souhaitez vous servir le cabinet ?<br>
            </div>
          <form [formGroup]="countriesForm" (ngSubmit)="onSubmitCountryForm()">
            <div class="form-group">
              <label for="country">Pays <span class="star-style">**</span></label>
              <select class="form-control" id="country" formControlName="country">
                <option value="">Selectionner...</option>
                <option [value]="country" *ngFor="let country of countryList">{{ country }}
                </option>
              </select>
            </div>
            <button type="submit" class="primary-btn text-white" [disabled]="countriesForm.invalid"
              *ngIf="!countryIsLoading">Ajouter</button>
            <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="countryIsLoading">Veuillez
              patienter...
            </p>

            <div class="form-group mt-5" style="width: 100%; overflow: auto;">
              <table class="table table-bordered">
                <tr>
                  <th>Pays souhaités</th>
                  <th>Action</th>
                </tr>
                <tr *ngFor="let consultantCountry of consultantCountryList">
                  <td>{{ consultantCountry.getCountry() }}</td>
                  <td><span class="btn btn-danger" (click)="removeCountry(consultantCountry.getId())">Supp</span>
                  </td>
                </tr>
              </table>
            </div>
          </form>
        </fieldset>
      </div>

    </div>
  </div>
</section>
<!-- End service Area -->